import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { formatDuration, formatTime } from '../../lib/utils/time';
import Card from '../shared/Card.svelte';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { formatVolume } from '../../lib/utils/units.ts';

var root_2 = $.from_html(`<span class="session-detail svelte-3ts66i1j0xzs8"> </span>`);
var root_3 = $.from_html(`<span class="session-detail svelte-3ts66i1j0xzs8"> </span>`);
var root_4 = $.from_html(`<span class="session-detail svelte-3ts66i1j0xzs8"> </span>`);
var root_5 = $.from_html(`<span class="session-duration svelte-3ts66i1j0xzs8"> </span>`);
var root_1 = $.from_html(`<div class="session-row svelte-3ts66i1j0xzs8"><div class="session-icon svelte-3ts66i1j0xzs8"> </div> <div class="session-info svelte-3ts66i1j0xzs8"><span class="session-type svelte-3ts66i1j0xzs8"> </span> <!> <!> <!></div> <div class="session-meta svelte-3ts66i1j0xzs8"><span class="session-time svelte-3ts66i1j0xzs8"> </span> <!></div></div>`);

function SessionCard($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');
	const typeLabels = { nursing: 'Nursed', pumping: 'Pumped', bottle: 'Bottle' };
	const typeIcons = { nursing: '🤱', pumping: '🍼', bottle: '🧴' };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	Card(node, {
		padding: 'sm',
		get onclick() {
			return $$props.onclick;
		},

		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var div_1 = $.child(div);
			var text = $.child(div_1, true);

			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var span = $.child(div_2);
			var text_1 = $.child(span, true);

			$.reset(span);

			var node_1 = $.sibling(span, 2);

			{
				var consequent = ($$anchor) => {
					var span_1 = root_2();
					var text_2 = $.child(span_1);

					$.reset(span_1);
					$.template_effect(() => $.set_text(text_2, `· ${$$props.session.side ?? ''}`));
					$.append($$anchor, span_1);
				};

				$.if(node_1, ($$render) => {
					if ($$props.session.side) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span_2 = root_3();
					var text_3 = $.child(span_2);

					$.reset(span_2);

					$.template_effect(($0) => $.set_text(text_3, `· ${$0 ?? ''}`), [
						() => formatVolume($$props.session.volumeMl, $.get(isImperial))
					]);

					$.append($$anchor, span_2);
				};

				$.if(node_2, ($$render) => {
					if ($$props.session.volumeMl) $$render(consequent_1);
				});
			}

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_2 = ($$anchor) => {
					var span_3 = root_4();
					var text_4 = $.child(span_3);

					$.reset(span_3);
					$.template_effect(() => $.set_text(text_4, `· ${$$props.session.source ?? ''}`));
					$.append($$anchor, span_3);
				};

				$.if(node_3, ($$render) => {
					if ($$props.session.source) $$render(consequent_2);
				});
			}

			$.reset(div_2);

			var div_3 = $.sibling(div_2, 2);
			var span_4 = $.child(div_3);
			var text_5 = $.child(span_4, true);

			$.reset(span_4);

			var node_4 = $.sibling(span_4, 2);

			{
				var consequent_3 = ($$anchor) => {
					var span_5 = root_5();
					var text_6 = $.child(span_5, true);

					$.reset(span_5);
					$.template_effect(($0) => $.set_text(text_6, $0), [() => formatDuration($$props.session.durationMs)]);
					$.append($$anchor, span_5);
				};

				$.if(node_4, ($$render) => {
					if ($$props.session.durationMs > 0) $$render(consequent_3);
				});
			}

			$.reset(div_3);
			$.reset(div);

			$.template_effect(
				($0) => {
					$.set_text(text, typeIcons[$$props.session.type]);
					$.set_text(text_1, typeLabels[$$props.session.type]);
					$.set_text(text_5, $0);
				},
				[() => formatTime($$props.session.startTime)]
			);

			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	SessionCard = $.hmr(SessionCard);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3ts66i1j0xzs8');
		SessionCard[$.HMR].update(module.default);
	});
}

export default SessionCard;
import "bun-svelte:SessionCard.svelte-nu52uwzolhyt-style.css";